<template>
  <div id="statisticalConfirm">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'statisticalConfirm'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/statistical/exhibition/confirm/StatisConfirm.vue